import ModalT1 from 'Components/SupplierPO/Modal';
import React from 'react';
import './tripsErrorLogs.scss';
import moment from 'moment';

const tripErrorLogs = (props) => {
    const { isModalPopupOpen, handleModalPopupClose, data } = props;

    return(
        <ModalT1 
            isOpenState={isModalPopupOpen}
            handleOnClickForClose={handleModalPopupClose}>
            <div className={'trip_error_logs'}>
                <div className={'fs-24 tCenter fBold'}>Trip Logs</div>
                <div className={'flex mt-10 mb-10 fs-16 fBold'}>
                    <div>Created Trips Count: <span className={"success-color"}>{data.created_trip_count}</span></div>
                    <div className={'ml-20'}>Error Trips Count: <span className={"error-color"}>{data.error_trip_count}</span></div>
                </div>
                <div className={'mt-20 col-1'}>
                    <table border={1} cellSpacing={0} cellPadding={5} width={'100%'}>
                        <tr className={'bg-theme white-color tCenter'}>
                            <th></th>
                            <th>From</th>
                            <th>To</th>
                            <th>Vehicle Type</th>
                            <th>Vehicle Body Type</th>
                            <th>Existing Contract Tenure To</th>
                            <th>Existing RFQ Number</th>
                            <th>Existing RFQ Name</th>
                            <th>Existing Floated By</th>
                        </tr>
                        {(data && data.list || []).map((trip, index) => {
                        return(<tr className={'tCenter'}>
                            <td>{index + 1}</td>
                            <td>{trip.from}</td>
                            <td>{trip.to}</td>
                            <td>{trip.vehicle_type_name}</td>
                            <td>{trip.vehicle_body_type_name}</td>
                            <td>{trip.existing_contract_tenure_to && moment(trip.existing_contract_tenure_to).format('DD/MM/YYYY') || ''}</td>
                            <td>{trip.existing_rfq_number}</td>
                            <td>{trip.existing_rfq_name}</td>
                            <td>{trip.existing_floated_by}</td>
                        </tr>)})}
                        {(data || []).length == 0 && (<tr className={'tCenter fBold'}><td colSpan={9}>{'No Data Found'}</td></tr>)}
                    </table>
                </div>
            </div>
        </ModalT1>
    )
}

export default tripErrorLogs;